import { useQuery } from '@tanstack/react-query';
import { FC } from 'react';

import { _getCountry } from '@/api/lookup/queries';
import { TextCell } from '@/design-system';

import { EntityTabTableRow } from '../data';

export const EntitiesTabTableState: FC<Pick<EntityTabTableRow, 'country' | 'stateRegion'>> = ({
  country,
  stateRegion,
}) => {
  const { data } = useQuery(_getCountry(country || ''));
  const stateName = data?.regions.find((r) => r.id === stateRegion)?.name;
  return <TextCell title={stateName ?? '-'} />;
};
